import { useState, useEffect, useRef } from "react";
import { Button, Checkbox, Modal } from "src/components";
import InvoiceMapping from "./invoice-mapping";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import successCircle from "src/assets/successCircle.svg";
import { useNavigate } from "react-router-dom";
import editPen from "src/assets/edit-pen.svg";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";
import { autoInvoiceEntry } from "src/services/invoice-api";
import { toast } from "src/hooks/useToast";
import useDebounceLeading from "src/hooks/useDebounceLeading";

const InvoiceProductMapping = () => {
  const [openProductMapping, setOpenProductMapping] = useState(false);
  const [mappingData, setMappingData] = useState<any>([]);
  const { invoicesTextractData, invoiceDetails } = useSelector((state: RootState) => state.invoice);
  const [isOriginalSet, setIsOriginalSet] = useState(false);
  const { invoiceMappingOriginalDescriptions } = useSelector((state: RootState) => state.invoice);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {        //M10-9685-MRP Related Issue
    if (invoicesTextractData.length > 0 && !isOriginalSet && invoiceMappingOriginalDescriptions?.length === 0) {
      const invoiceMappingOriginalDescription = invoicesTextractData.reduce(
        (acc: Record<string, string>, row: any) => {
          if (row?.invoice_product_id && row?.textractProduct_item_description) {
            acc[row.invoice_product_id] = row.textractProduct_item_description;
          }
          return acc;
        },
        {}
      );
      dispatch(invoiceActions.setInvoiceMappingOriginalDescriptions(invoiceMappingOriginalDescription));
      setIsOriginalSet(true);
    }
  }, [invoicesTextractData, isOriginalSet, invoiceMappingOriginalDescriptions]);

  const isRequestInProgress = useRef(false);

  const handleSubmitEntryInvoice = useDebounceLeading(async () => {
    if (isRequestInProgress.current) return;

    isRequestInProgress.current = true;

    try {
      const invoiceId = invoiceDetails?.invoice?.invoice_id;
      const companyCode = invoiceDetails?.company_code;
      const stockistId = invoiceDetails?.stockist_invoice_attachment_id;

      if (!invoiceId || !companyCode) {
        toast({ description: "Missing invoice or company information", variant: "destructive" });
        return;
      }

      const response = await autoInvoiceEntry(
        {
          data: { invoice_id: invoiceId },
          primary_key: invoiceId,
        },
        companyCode
      );

      const { autoEntry, message } = response?.data?.data || {};

      if (autoEntry === false) {
        navigate(`/transactions/invoice/${stockistId}/0`);
      } else {
        toast({ description: message || "Invoice processed successfully." });
        navigate("/transactions/invoice");
      }
    } catch (error: any) {
      console.error("Auto entry error:", error);
      toast({ description: error?.response?.data?.message || "Something went wrong.", variant: "destructive" });
    } finally {
      isRequestInProgress.current = false;
    }
  }, 1000);

  return (
    <div className="min-h-[400px]">
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          border: "1px solid #ccc",
          // height:"300px"
        }}
        className="mt-10"
      >
        <thead>
          <tr className="text-sm bg-[#F1F1F1]">
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}></th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Invoice Product Description</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Master Product Description</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Map</th>
            <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Edit</th>
          </tr>
        </thead>
        <tbody>
          {/* M10-9685-MRP Related Issue - serial no issue */}
          {[...new Map(invoicesTextractData.map((item: any) => [(invoiceMappingOriginalDescriptions[item?.invoice_product_id] || "").replace(/[^\w\s]/gi, ""), item])).values(),].sort((a: any, b: any) => {
            const idA = a?.id || 0;
            const idB = b?.id || 0;
            return idA - idB;
          }).map(
            (row: any, index: any) => (
              (
                <tr key={index} className="w-full">
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[20%] text-gray-500">
                    <Checkbox />
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[20%] text-sm">
                    {invoiceMappingOriginalDescriptions[row?.invoice_product_id] || row?.item_description}
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[32%] text-sm">
                    {row?.is_item_unknown === false ? row?.item_description : "-"}
                  </td>
                  {row?.is_item_unknown ? (
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                      <div
                        onClick={() => {
                          setMappingData(row);
                          if (mappingData) {
                            setOpenProductMapping(true);
                          }
                        }}
                      >
                        <button className="px-2 py-1 bg-gray-200 rounded-md">↔</button>
                      </div>
                    </td>
                  ) : (
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                      <img src={successCircle} alt="cross" className="w-5 h-5 font-bold cursor-pointer" />
                    </td>
                  )}
                  <td style={{ padding: "0px", borderBottom: "1px solid #ccc" }} className="w-[6%]">
                    {row?.is_item_unknown === false && <Button onClick={() => {
                      setMappingData(row);
                      if (mappingData) {
                        setOpenProductMapping(true);
                      }
                    }}>
                      <img src={editPen} alt="delete" className="w-4 h-4" />
                    </Button>}
                  </td>
                </tr>
              )
            )
          )}
        </tbody>
      </table>
      <div className="flex justify-between mt-14 gap-x-2">
        <>
          <Button
            onClick={() => {
              navigate(`/transactions/invoice/${invoiceDetails?.stockist_invoice_attachment_id}/${0}`);
            }}
            className="font-normal bg-gray-200 border border-gray-300"
          >
            Go Manual
          </Button>
        </>
        <div className="flex gap-x-2">
          <Button className="font-normal bg-gray-200 border border-gray-300">Escalate to Master</Button>
          <Button
            disabled={isRequestInProgress.current}
            onClick={handleSubmitEntryInvoice}
            // onClick={async () => {
            //   // if (invoicesTextractData?.some((item: any) => item?.is_item_unknown === true)) {
            //   //   toast({
            //   //     description: "Please map all unknown items",
            //   //     variant: "destructive",
            //   //   });
            //   //   return;
            //   // }
            //   const autoEntryResponse = await autoInvoiceEntry({
            //     "data": {
            //       "invoice_id": invoiceDetails?.invoice?.invoice_id
            //     },
            //     "primary_key": invoiceDetails?.invoice?.invoice_id
            //   }, invoiceDetails?.company_code)
            //   if (autoEntryResponse?.data?.data?.autoEntry == false) {
            //     navigate(`/transactions/invoice/${invoiceDetails?.stockist_invoice_attachment_id}/0`);
            //   } else {
            //     toast({ description: autoEntryResponse?.data?.data?.message });
            //     navigate("/transactions/invoice");
            //   }
            // }}
            className="font-normal text-white bg-primary"
          >
            Confirm Invoice
          </Button>
        </div>
      </div>
      <Modal isOpen={openProductMapping} isHeader={false} onCloseModal={() => setOpenProductMapping(false)} title="Escalate Invoice">
        <InvoiceMapping onCloseModal={() => setOpenProductMapping(false)} mappingData={mappingData} />
      </Modal>
    </div>
  );
};

export default InvoiceProductMapping;
